import _ from 'lodash/fp';
import React, { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import classNames from 'classnames';
import { nextHighResLayer, prevHighResLayer } from '../../../redux/actions';
import Icon from '../../icon/Icon';
export var HIGH_RES_DATE_ID = 'high-res-date-wrapper';
var HighResDate = function(param) {
    var isVisible = param.isVisible;
    var dispatch = useDispatch();
    var _useSelector = useSelector(function(state) {
        return state.mapReducer;
    }), _useSelector_highRes = _useSelector.highRes, currentDate = _useSelector_highRes.currentDate, layers = _useSelector_highRes.layers;
    var dates = !layers.isLoading && layers.data ? _.keys(layers.data) : null;
    var isCurrentDateLatest = dates ? dates.indexOf(currentDate) === 0 : false;
    var isCurrentDateEarliest = dates ? dates.indexOf(currentDate) === dates.length - 1 : false;
    var isNextDisabled = layers.isLoading || !currentDate || isCurrentDateLatest;
    var isPrevDisabled = layers.isLoading || !currentDate || isCurrentDateEarliest;
    var formattedDate = useMemo(function() {
        if (currentDate) {
            var date = new Date(currentDate);
            return date.toLocaleDateString('en-AU', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit'
            });
        }
        return null;
    }, [
        currentDate
    ]);
    return /*#__PURE__*/ React.createElement("div", {
        id: HIGH_RES_DATE_ID,
        className: classNames('high-res-date', isVisible && 'visible')
    }, formattedDate ? /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("button", {
        type: "button",
        className: "action left",
        disabled: isPrevDisabled,
        onClick: function() {
            return dispatch(nextHighResLayer());
        }
    }, /*#__PURE__*/ React.createElement(Icon, {
        icon: "chevron-left"
    })), /*#__PURE__*/ React.createElement("div", {
        className: "date"
    }, formattedDate), /*#__PURE__*/ React.createElement("button", {
        type: "button",
        className: "action right",
        disabled: isNextDisabled,
        onClick: function() {
            return dispatch(prevHighResLayer());
        }
    }, /*#__PURE__*/ React.createElement(Icon, {
        icon: "chevron-right"
    }))) : null);
};
export default HighResDate;
